import { useEffect } from 'react';
import { useContinueButtonStore } from 'src/easyclaim.app.stores/useContinueButtonStore';

import ButtonConfiguration from './ButtonConfiguration';

interface ContinueButtonSyncProps {
	config: ButtonConfiguration;
}

export function ContinueButtonSync({ config }: ContinueButtonSyncProps) {
	const setConfig = useContinueButtonStore((s) => s.setConfig);

	useEffect(() => {
		setConfig({
			isDisabled: config.disabled ?? false,
			isVisible: config.isVisible,
			textId: config.textId,
			onClick: config.onClick,
		});
	}, [config.disabled, config.isVisible, config.textId, config.onClick, setConfig]);

	return null;
}
